import React from 'react';

interface MarkdownProps {
  content: string;
  className?: string;
}

export function Markdown({ content, className = '' }: MarkdownProps) {
  // Simple markdown parser for basic formatting
  const parseMarkdown = (text: string) => {
    if (!text) return '';

    // Convert markdown to HTML
    let html = text;

    // Convert headers
    html = html.replace(/^## (.+)$/gm, '<h3 class="text-sm font-medium mb-2">$1</h3>');
    html = html.replace(/^### (.+)$/gm, '<h4 class="text-xs font-medium mb-2">$1</h4>');

    // Process lists more carefully
    const listItemRegex = /^[*-] (.+)$/gm;
    if (listItemRegex.test(html)) {
      // Split by lines to process lists properly
      const lines = html.split('\n');
      let inList = false;
      let processedLines = [];

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        const isListItem = line.match(/^[*-] (.+)$/);

        if (isListItem) {
          if (!inList) {
            inList = true;
            processedLines.push('<ul class="list-disc pl-5 mb-3 space-y-2">');
          }
          processedLines.push(`<li class="text-xs">${isListItem[1]}</li>`);
        } else {
          if (inList) {
            inList = false;
            processedLines.push('</ul>');
          }
          processedLines.push(line);
        }
      }

      if (inList) {
        processedLines.push('</ul>');
      }

      html = processedLines.join('\n');
    }

    // Convert paragraphs (double newlines)
    html = html.replace(/\n\n/g, '</p><p class="text-xs mb-4">');

    // Convert single newlines to <br> (but not inside lists or after headers)
    html = html.replace(/(?<!\<\/li\>)(?<!\<\/h[34]\>)\n(?!\<(ul|\/ul|li|h[34]))/g, '<br>');

    // Bold text
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

    // Italic text
    html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');

    // Wrap in paragraph tags if not already wrapped
    if (!html.startsWith('<ul') && !html.startsWith('<h3') && !html.startsWith('<h4') && !html.startsWith('<p')) {
      html = `<p class="text-xs mb-4">${html}</p>`;
    }

    return html;
  };

  return (
    <div
      className={`markdown-content ${className}`}
      dangerouslySetInnerHTML={{ __html: parseMarkdown(content) }}
      style={{
        '--header-spacing': '0.75rem',
        '--content-spacing': '0.5rem'
      } as React.CSSProperties}
    />
  );
}
